import React from 'react';

//Common Input
export const Input = props => {
  const {
    input,
    label,
    type,
    ID,
    name,
    autoComplete,
    hidden,
    meta: { touched, error, submitFailed }
  } = props;
  return (
    <div>
      {!hidden && <label>{label}</label>}
     
        <input {...input} placeholder={label} type={type} hidden={hidden} autoComplete={autoComplete} className={(touched && error)?"error_state":""}/>
        {touched && error && <span>{error}</span>}
      
    </div>
  );
};

//Common single input
export const SignupInput = props => {
  const {
    input,
    label,
    type,
    ID,
    name,
    value,
    autoComplete,
    meta: { touched, error, submitFailed }
  } = props;
  return (
    <div>
      <label>{label}</label>
     
        <input {...input} placeholder={label} type={type} autoComplete={autoComplete} className={(touched && error)?"error_state":""}/>
        {touched && error && <span>{error}</span>}
        
    </div>
  );
};

//Common Select Options
export const RejectReason = props => {
  const {
    input,
    label,
    type,
    name,
    options = [],
    meta: { touched, submitFailed, error }
  } = props;
  return (
    <div >
    <select className="form-control reqst-cntrl" id="FormControlSelect" {...input} id={name} >
          <option value="" >Select Reason</option>
          {options.map((o, index)=>
                <option key= {index}>{o}</option>
              )}
        </select>
      <div >
        
        {submitFailed &&
          (error && (
            <div className="alert-danger error">{`${input.name} is ${error}`}</div>
          ))}
      </div>
    </div>
  );
};

//Handle Reject reason for campaign
export const RejectOther = props => {
  const {
    input,
    label,
    type,
    name,
    placeholder,
    errorStatus,
    meta: { touched, error, submitFailed }
  } = props;

  let inputClass='form-control';

  if((submitFailed && error) || errorStatus){
    inputClass='form-control fillGst'
  }

  return (
    <div className="input-tag signup-tag clearfix other_textarea">

      <label htmlFor={name}>
        {label}
      </label>
        <textarea
          {...input}
          type={type}
          className={inputClass}
          id={name}
          placeholder={placeholder}
        />
    </div>
  );

};

//Common Contact input
export const InputContact = props => {
  const {
    input,
    type,
    placeholder,
    meta: { touched, error, submitFailed }
  } = props;
  return (
    <div className="contact_input">
        <input {...input} placeholder={placeholder} type={type} className={(touched && error)?"error_state":""}/>      
    </div>
  );
};

//Common Text Area
export const TextArea = props => {
  const {
    input,
    label,
    type,
    name,
    myVal,
    changeName,
    meta: { touched, submitFailed, error }
  } = props;
  return (
    <div className="form-group clearfix">
      <label className="control-label" htmlFor={name}>
        {label}
      </label>
      <div className="">
        <textarea
          {...input}
          className="form-control"
          id={name}
          value={myVal}
          placeholder={label}
          onChange={changeName}
        />
        {submitFailed &&
          (error && (
            <div className="alert-danger error">{`${label} is ${error}`}</div>
          ))}
      </div>
    </div>
  );
};

//Common Dropdown
export const DropDown = props => {
  const {
    input,
    label,
    type,
    name,
    options = [],
    arrow,
    inputArray,
    meta: { touched, submitFailed, error }
  } = props;
  return (
    <div >
      <label>
        {label}
      </label>
      <div className="">
      <select {...input} id={name} className={input.value.length > 0 ?"select_state" :arrow} required >
          <option value=""  disabled  className="select_placeholder">Select Your {label}</option>
          {options.map(o => (
            <option key={`${name}-${o.get('value')}`} value={o.get('name')}>
              {o.get('name')}
            </option>
          ))}
        </select>
        {/* {submitFailed &&
          (error && (
            <div className="alert-danger error">{`${label} is ${error}`}</div>
          ))} */}
      </div>
    </div>
  );
};

//Dropdown for contact
export const DropDownContact = props => {
  const {
    input,
    label,
    name,
    options = [],
    arrow,
    meta: { touched, submitFailed, error }
  } = props;
  return (
      // <div className="contact_input">
      <select {...input} required >
          <option value=""  disabled >Select Your State</option>
          {options.map(o => (
            <option key={`${name}-${o.get('value')}`} value={o.get('name')}>
              {o.get('name')}
            </option>
          ))}
          <option value="Outside India"  >Outside India</option>
        </select>
      // </div>
  );
};

//Dropdown for contact
export const DropDownContactDistrict = props => {
  const {
    input,
    label,
    name,
    options = [],
    arrow,
    meta: { touched, submitFailed, error }
  } = props;
  return (
      // <div className="contact_input">
      <select {...input} required >
          <option value=""  disabled >Select Your City</option>
          {options.map(o => (
            <option key={`${name}-${o.get('value')}`} value={o.get('name')}>
              {o.get('name')}
            </option>
          ))}
        </select>
      // </div>
  );
};




// WEBPACK FOOTER //
// ./web/components/common/input.js